export const initialState = {
  homeworks: [],
};
